import React, { useEffect, useState } from 'react';
import { selectCurrentLanguage } from '../../../features/auth/authSlice';
import { useGetOptionCategoriesQuery } from '../../../features/details/detailsApiSlice';
import CategorySelect from './../ClientOffice/JobPosting/CategorySelect';
import { useSelector } from 'react-redux';
import { fireCategoriesTr } from './../../../utils/firebase.config';

const CategoriesList = ({ setMasterCategories, categories }) => {
    const lang = useSelector(selectCurrentLanguage);
    const [trCategoriesArr, setTrCategoriesArr] = useState(null);
    const { data: optionCategories, isLoading } = useGetOptionCategoriesQuery();
    const [newCategoryFK, setCategoryFK] = useState(null);

    useEffect(() => {
        if (!isLoading) {
            fireCategoriesTr(setTrCategoriesArr); 
        }
    }, [isLoading]);

    // adding category
    function addKeyword(categoryFK = newCategoryFK) {
        let newC = null;
        for (const c of (optionCategories || [])) {
            if (c.id == categoryFK) {
                if (!(categories || []).find(nc => nc.id == categoryFK)) {
                    newC = { ...c };
                    setMasterCategories(prev => [...(prev || []), newC]);
                }
                break;
            }
        }
    }

    const removeKeyword = (cFK) => {
        setMasterCategories(prev => (prev || []).filter(nc => nc.id != cFK));
    }
    
    return <div className="keywords-container">
        {!isLoading &&
        <div className="keyword-input-container margin-bottom-10">
            <CategorySelect setCategoryFK={categoryFK => {
                setCategoryFK(categoryFK);
                addKeyword(categoryFK);
            }} />
            <button type="button" onClick={() => addKeyword()} className="keyword-input-button ripple-effect"><i className="icon-material-outline-add"></i></button>
        </div>}
        <div className="keywords-list" style={{ width: '100%', height: 'max-content' }}>
            {categories?.map(c => {
                let index = trCategoriesArr?.input?.indexOf(c.category);
                return <span key={c?.id} className="keyword"><span onClick={() => removeKeyword(c?.id)} className="keyword-remove"></span><span className="keyword-text">{(trCategoriesArr?.translated && trCategoriesArr.translated[index]) ? trCategoriesArr.translated[index][lang] : c?.category}</span></span>
            })}
        </div>
        <div className="clearfix"></div>
    </div>;
}

export default CategoriesList;
